<ami-dialog-message [setting]="message"></ami-dialog-message>

<ami-table-actions
  [settings]="table.settings"
  [data]="table.data"
  [actions]="table.actions"
  (action)="onReciveAction($event)"
></ami-table-actions>

<div class="justify-content-end p-fluid p-formgrid grid">
  <div class="field col-12 md:col-2">
    <button
      type="button"
      pButton
      pRipple
      (click)="prevPage()"
      icon="pi pi-angle-left"
      iconPos="left"
      label="Anterior"
    ></button>
  </div>
  <div class="field col-12 md:col-2">
    <button
      type="button"
      pButton
      (click)="nextPage()"
      pRipple
      icon="pi pi-angle-right"
      iconPos="right"
      [disabled]="isCartEmpty()"
      label="Siguiente"
    ></button>
  </div>
</div>
